import Pusher from 'pusher-js';
import Lots from './Lots';

const LOOP_TIME = Number(process.env.VUE_APP_LOOP_TIME_LOTS) || 10000;
const REVERB_KEY = process.env.VUE_APP_REVERB_APP_KEY || 'local-disponibilidade-reverb-key';

let pusher = null;
let channel = null;
let currentAllotment = null;
let fallbackTimer = null;
let onUpdate = null;

function backendHost() {
    try {
        return new URL(process.env.VUE_APP_BACK_END).hostname;
    } catch (e) {
        return window.location.hostname;
    }
}

function pusherOptions() {
    const scheme = process.env.VUE_APP_REVERB_SCHEME || 'http';
    const port = process.env.VUE_APP_REVERB_PORT || 8080;

    return {
        cluster: process.env.VUE_APP_REVERB_CLUSTER || 'mt1',
        wsHost: process.env.VUE_APP_REVERB_HOST || backendHost(),
        wsPort: port,
        wssPort: port,
        forceTLS: scheme === 'https',
        enabledTransports: ['ws', 'wss'],
        disableStats: true,
        channelAuthorization: {
            endpoint: `${process.env.VUE_APP_BACK_END}/broadcasting/auth`,
            transport: 'ajax',
            // Lido a cada autorização: o token é renovado sem recarregar a página.
            // company-id: o backend checa a mesma permissão da rota listarModificados.
            headersProvider: () => {
                const headers = {Authorization: `Bearer ${localStorage.getItem('access_token')}`};
                const companyId = localStorage.getItem('companyId');
                if (companyId) {
                    headers['company-id'] = companyId;
                }
                return headers;
            },
        },
    };
}

function nowFormatted() {
    const time = new Date();
    const time2 = new Date(time.valueOf() - time.getTimezoneOffset() * 60000);
    return time2.toISOString().slice(0, 19).replace('T', ' ');
}

function startFallback() {
    if (fallbackTimer || !onUpdate) {
        return;
    }
    fallbackTimer = setInterval(() => {
        const allotmentId = currentAllotment || localStorage.getItem('allotmentId');
        if (!allotmentId) {
            return;
        }
        Lots.listModified(nowFormatted(), allotmentId)
            .then(resp => onUpdate(resp.data))
            .catch(() => {});
    }, LOOP_TIME);
}

function stopFallback() {
    clearInterval(fallbackTimer);
    fallbackTimer = null;
}

export function subscribeLotsUpdated(allotmentId, callback) {
    if (!allotmentId) {
        return;
    }
    onUpdate = callback;
    if (channel && currentAllotment === allotmentId) {
        return;
    }
    unsubscribeLotsUpdated();
    currentAllotment = allotmentId;
    try {
        if (!pusher) {
            pusher = new Pusher(REVERB_KEY, pusherOptions());
            pusher.connection.bind('state_change', states => {
                const state = states.current || states;
                if (['disconnected', 'failed', 'unavailable'].includes(state)) {
                    startFallback();
                } else if (state === 'connected') {
                    stopFallback();
                }
            });
        }
        channel = pusher.subscribe(`private-lots-updated.${allotmentId}`);
        channel.bind('lots.updated', payload => {
            if (payload && payload.lots) {
                onUpdate(payload.lots);
            }
        });
        channel.bind('pusher:subscription_error', () => startFallback());
        channel.bind('pusher:subscription_succeeded', () => stopFallback());
    } catch (e) {
        startFallback();
    }
}

export function unsubscribeLotsUpdated() {
    stopFallback();
    if (channel) {
        if (pusher && currentAllotment) {
            pusher.unsubscribe(`private-lots-updated.${currentAllotment}`);
        }
        channel = null;
    }
    currentAllotment = null;
}

export function disconnectLotsBroadcast() {
    unsubscribeLotsUpdated();
    onUpdate = null;
    if (pusher) {
        pusher.disconnect();
        pusher = null;
    }
}
